import React from 'react'

export default ({ children }) => (
  <div style={{ maxWidth: 1180, margin: '0 auto' }}>{children}</div>
)



// WEBPACK FOOTER //
// ./src/components/container.js